var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('MessageCreated',{attrs:{"channel":_vm.privateChannel}}),_vm._v(" "),_c('div',{class:_vm.$style.chatContainer},[(_vm.hasStreamEnded)?_c('h3',[_vm._v("\n      Live stream has ended\n    ")]):_vm._e(),_vm._v(" "),_c('ChatWindow',{attrs:{"activity":_vm.activity,"focus":true,"request-url":_vm.requestUrl,"read-only":_vm.hasStreamEnded}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed9cf396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/meetings/LiveCoach/LiveCoach.vue
// module id = RJfj
// module chunks = 1